<script>
    import vSelect from 'vue-select';

    export default {
        extends: vSelect,
        watch: {
            ...vSelect.$watch,
            value(newVal) {
                const option = this.findOptionFromReducedValue(newVal);
                if (option) {
                    this.updateValue(option);
                } else {
                    this.updateValue('');
                }
            }
        }
    }
</script>
